// TalentSwap's X/Twitter account. This is the single place the handle lives:
// everything that links to X (e.g. the "beta is full" sign-in state) imports it from here.
export const X_PROFILE_URL = 'https://x.com/talentswapshop'
